import axios from 'axios';

const base = 'analitica-asesor';

function getAnaliticaIndividual(data) {
    return axios.post(`${base}/individual`, data);
}

function getAsesoresLista() {
    return axios.get(`${base}/asesores`);
}

function getAnaliticaGeneral(data) {
    return axios.post(`${base}/general`, data);
}

const AnaliticaAsesorService = {
    getAnaliticaIndividual,
    getAsesoresLista,
    getAnaliticaGeneral,
};

export default AnaliticaAsesorService;
